import { render, staticRenderFns } from "./PostIndex.vue?vue&type=template&id=18392468&"
import script from "./PostIndex.vue?vue&type=script&lang=js&"
export * from "./PostIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports